module.exports = "/images/Moldova.png?3784eaacc6d7f7532dc5bce721aba69f";